<template>
  <div>
  <div :key="item.tid" v-for="item in tags">
    <div   class="tag-label">
      <svg width="15" height="14" viewBox="0 0 15 14" fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <path
            d="M14.0625 7.00007C14.0625 10.5899 11.1524 13.5001 7.5625 13.5001C3.97265 13.5001 1.0625 10.5899 1.0625 7.00007C1.0625 3.41021 3.97265 0.500061 7.5625 0.500061C11.1524 0.500061 14.0625 3.41021 14.0625 7.00007Z"
            :fill="'url(#paint0_linear_19_1637' + item.tid + ')'"
            stroke="#0A5256"/>
        <defs>
          <linearGradient :id="'paint0_linear_19_1637' + item.tid" x1="7.5625"
                          y1="6.10352e-05" x2="7.5625" y2="14.0001"
                          gradientUnits="userSpaceOnUse">
            <stop :stop-color="stopColor"/>
            <stop offset="1" :stop-color="offsetColor"/>
          </linearGradient>
        </defs>
      </svg>
      <div class="inner">
        {{ item.name }}
      </div>

    </div>
  </div>
    <div v-if="!showAll && group.length > 2" @click="showAllTags">...</div>
  </div>
</template>
<script setup lang="ts">

import {computed, ref} from "vue";

const props = defineProps({
  group: Array,
  stopColor: String,
  offsetColor: String
});

const showAll = ref(false);

function indexHidden(index) {
  return showAll.value == true || index > 2;
}

const tags = computed(() => {
  if(showAll.value == true) {
    return props.group;
  }
  else {
    return props.group.slice(0, 2);
  }
})

function showAllTags() {
  showAll.value = !showAll.value;
}

</script>
